import { useDispatch, useSelector } from 'react-redux';
import useEventListener from '../../../../hooks/useEventListener';
import VCSModule from '../../../../redux/vcs';
import useService from './useService';
import type { ServiceQueryParameters } from '../../../../types';
import useIsGithubApp from './useIsGithubApp';

/**
 * Refetches the Github App filters and repositories when the window is focused.
 * This hook ensure the installation list is up-to-date when the user returns to the tab.
 */
const useRefetchGithubAppFiltersOnFocus = () => {
  const dispatch = useDispatch();
  const isGithubApp = useIsGithubApp();
  const service = useService();
  const query = useSelector(VCSModule.selectors.getQueryParameters) as ServiceQueryParameters;
  const isAuthenticated = useSelector(VCSModule.selectors.getIsConnected);

  useEventListener('focus', () => {
    // Only refetch the filters if the user is authenticated and the service is a Github App.
    // This is to avoid unnecessary API calls for other service because they don't have an installation process
    // that would alter the filters constantly.
    if (isGithubApp && isAuthenticated) {
      const isRefetch = true;
      dispatch(VCSModule.actions.fetchFilters(service, query.instanceName, isRefetch));
      // Only refetch the repositories if the user has selected a user or organization.
      if (query.filterValue) {
        dispatch(VCSModule.actions.fetchRepositories(service, query, isRefetch));
      }
    }
  });
};

export default useRefetchGithubAppFiltersOnFocus;
